module.exports = __webpack_public_path__ + "static/media/leaf-heart.a69b0e3e.svg";